















































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import SumupTab from "../../components/SumupTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, ScoreRateHeaderItem, ScoreRateItem, ScoreRateRoomItem, ScoreRateRowItem } from '../../modules/teacher/SumupScoreDistributionList';


export interface Data {
  tabNo: number
  sheet_group_key: string
  sheet: Sheet | null
  scoreRateRowItems: ScoreRateRowItem[]
  scoreRateHeaderItems: ScoreRateHeaderItem[]
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number}>
  errors: string[]
}

export default defineComponent({
  components: {
    "sumup-tab": SumupTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 2,
      sheet_group_key: "",
      sheet: null,
      scoreRateRowItems: new Array<ScoreRateRowItem>(),
      scoreRateHeaderItems: new Array<ScoreRateHeaderItem>(),
      SheetTypeEnum: Common.SheetTypeEnum,
      errors: [],
    });


    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      await http.get(`/api/teacher/sumup_score_distribution_list?sheet_group_key=${state.sheet_group_key}`).then(response => {
        
        state.sheet = new Sheet(response.data.sheet);

        const scoreRateItems: ScoreRateItem[] = response.data.score_rates.map((x: any) => new ScoreRateItem(x.room_name, x.score_rate));
        const roomNames = Array.from(new Set(scoreRateItems.map(x => x.room_name)));
        const perFromArray = [91, 81, 71, 61, 51, 41, 31, 21, 11, 0];
        const perToArray = [100, 90, 80, 70, 60, 50, 40, 30, 20, 10];
        for(let i = 0; i < perFromArray.length; i++){
          const perFrom = perFromArray[i];
          const perTo = perToArray[i];
          
          const scoreRateRoomItems = new Array<ScoreRateRoomItem>();
          scoreRateRoomItems.push(new ScoreRateRoomItem("全体", perFrom, perTo, scoreRateItems));
          roomNames.forEach(roomName => {
            scoreRateRoomItems.push(new ScoreRateRoomItem(roomName, perFrom, perTo, scoreRateItems.filter(x => x.room_name == roomName)));
          });

          const scoreRateRowItem = new ScoreRateRowItem(perFrom, perTo, scoreRateRoomItems);
          state.scoreRateRowItems.push(scoreRateRowItem);
        }

        state.scoreRateHeaderItems.push(new ScoreRateHeaderItem("全体", scoreRateItems.length));
        roomNames.forEach(roomName => {
          state.scoreRateHeaderItems.push(new ScoreRateHeaderItem(roomName, scoreRateItems.filter(x => x.room_name == roomName).length));
        });
        
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
    };
  }
});

